import React, { useState } from "react";
import {
	Alert,
	AppBar,
	Box,
	Button,
	Container,
	Dialog,
	DialogContent,
	FormControlLabel,
	FormLabel,
	Grid,
	IconButton,
	Paper,
	Radio,
	RadioGroup,
	Slide,
	Stack,
	styled,
	Switch,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	TextField,
	Toolbar,
	Tooltip,
	Typography,
} from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import { isEmpty } from "lodash";
import OfferingTable from "./OfferingTable";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/loader/Loader";
import { showLoading } from "../../redux/actions/collection.actions.";
import AnimatedButton from "../../components/comman/buttons/buttons";
import { toast } from "react-hot-toast";
const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});
export default function CollectionDilogbox(props) {
	const { loading } = useSelector((state) => state.collectionReducer);
	const dispatch = useDispatch();
	const [alertMessage, setAlertMessage] = useState("");
	const Item = styled(Paper)(({ theme }) => ({
		backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
		...theme.typography.body2,
		padding: theme.spacing(1),
		textAlign: "center",
		color: theme.palette.text.secondary,
	}));
	const {
		open,
		setOpen,
		brands,
		offers,
		setnewCollection,
		newCollection,
		createCollection,
		collections
	} = props;
	const [checked, setChecked] = React.useState([]);
	const [allCV, setAllCV] = React.useState(false);
	const [checkedOffer, setCheckedOffer] = useState([]);
	const [offerbySource, setOfferbySource] = useState([]);
	const [error, setError] = useState({
		name_error: true,
		details_error: true,
		offer_error: true,
	});
	const [offerList, setOfferingList] = useState([]);
	const handleSource = (value) => async () => {
		const currentIndex = checked.indexOf(value);
		const newChecked = [...checked];

		if (currentIndex === -1) {
			newChecked.push(value);
		} else {
			newChecked.splice(currentIndex, 1);
		}
		setChecked(newChecked);

		let offer = await offers.filter((e) => {
			return newChecked.includes(e.source_business_id);
			// return e.source_business_id == value;
		});
		setOfferbySource([...offer]);
		// setOfferbySource([...offerbySource,...offer]);	
	};


	const handleOffer = (value) => () => {
		const currentIndex = checkedOffer.indexOf(value);
		//console.log("value is ",value);
		const currentIndexSource = checked.indexOf(value.source_business_id);
		if (currentIndexSource == -1) {
			const newSourceChecked = [...checked];
			newSourceChecked.push(value.source_business_id);
			setChecked(newSourceChecked);
		}

		const newChecked = [...checkedOffer];

		if (currentIndex === -1) {
			newChecked.push(value);
		} else {
			newChecked.splice(currentIndex, 1);
		}

		setCheckedOffer(newChecked);
		const offers = newChecked.map((e) => {
			return e.offering_id;
		});
		setnewCollection({ ...newCollection, ["offerings"]: offers });
		error.offer_error = false;
	};
	const handleSourceClick = (id) => async () => {
		let offer = await offers.filter((e) => {
			return e.source_business_id == id;
		});
		setOfferbySource(offer);
	};

	function collectionNameExists(collection_name) {
		let arr = collections.filter((item) => item.collection_name.toLowerCase().trim() === collection_name.toLowerCase().trim())
		if (arr.length > 0) {
			console.log("Collections list:" + true);
			return true
		} else {
			console.log("Collections list:" + false);
			return false
		}
	}

	const handleTextFieldChange = (e) => {
		const { name, value } = e.target;
		if (!isEmpty(e.target.value)) {
			if (e.target.id === "collection_name") {
				error.name_error = false;
			}
			if (e.target.id === "details") {
				error.details_error = false;
			}
		} else {
			if (e.target.id === "collection_name") {
				error.name_error = true;
			}
			if (e.target.id === "details") {
				error.details_error = true;
			}
		}
		if (name === "is_locked") {
			setAllCV(false);
			setnewCollection({ ...newCollection, [name]: value });
		} else {
			setnewCollection({ ...newCollection, [e.target.id]: e.target.value });
		}
		//console.log("collection",newCollection);
	};
	const handleSaveClick = async () => {
		if(newCollection?.length === 0 || isEmpty(newCollection.collection_name) || isEmpty(newCollection.details)) {
			toast.error("Please fill all the required fields.");
			return;
		}
		dispatch(showLoading(true));
		if (collectionNameExists(newCollection.collection_name)) {
			dispatch(showLoading(false));
			setAlertMessage("Collection name already exists.")
			toast("Collection name already exists.", { icon: "⚠️" });
			return
		}
		if (createCollection({ ...newCollection, ["created_by"]: "Amit001", ["modified_by"]: "Amit001" })) {
			toast.success("Collection created successfully.");
			handleClose();
		}
	};
	// console.log(newCollection)

	const handleClose = () => {
		setAlertMessage("");
		setOpen(false);
		setChecked([]);
		setnewCollection([]);
		setCheckedOffer([]);
		setAllCV(false);
	};

	const handleRowSelection = (e) => {
		setOfferingList(e);
		let data = e.map((id) => {
			return {
				"offering_id": id,
				"priority": '-1'
			}
		})
		setnewCollection({ ...newCollection, ["offerings"]: data });
	}

	const handleAllCV = () => {
		setAllCV(true);
	}

	useEffect(() => {
		setAlertMessage("");
	}, [])

	return (<>
		<Dialog
			open={open}
			onClose={handleClose}
			TransitionComponent={Transition}
			fullWidth
			maxWidth='xl'
			scroll='paper'
			PaperProps={{
				sx: {
					borderRadius: 3,
					overflow: "hidden",
					maxHeight: "92vh",
					border: "1px solid rgba(148, 163, 184, 0.35)",
					background: "#ffffff",
				},
			}}
			BackdropProps={{
				sx: {
					backdropFilter: "blur(6px)",
					backgroundColor: "rgba(2, 6, 23, 0.6)",
				},
			}}
		>
			<AppBar
				sx={{
					position: "relative",
					background:
						"linear-gradient(90deg, #1d4ed8 0%, #2563eb 50%, #06b6d4 100%)",
				}}
			>
				<Toolbar>
					<IconButton
						edge='start'
						color='inherit'
						onClick={handleClose}
						aria-label='close'>
						<CloseIcon />
					</IconButton>
					<Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
						Collection
					</Typography>
					{
						<AnimatedButton
							label={`Save Collection`}
							icon={<SaveIcon />}
							// disabled={
							// 	loading || error.details_error || error.name_error || !offerList?.length > 0
							// }
							onClick={handleSaveClick}
							sx={{
								background: 'linear-gradient(45deg, #ffffff 30%, #ffffff 90%)',
								color: 'black',
								cursor: 'pointer',
								'&:disabled': {
									backgroundColor: '#e0e0e0',
									color: '#9e9e9e',
								},
							}}
						/>
					}
				
				</Toolbar>
			</AppBar>
			<DialogContent
				dividers
				sx={{
					p: 0,
					overflowX: "hidden",
					overflowY: "auto",
					maxHeight: "calc(92vh - 64px)",
				}}
			>
				{alertMessage && (
					<Alert
						onClose={() => {
							setAlertMessage("");
						}}
						severity="error">
						{alertMessage}
					</Alert>
				)}
				{
					loading ? <Loader status={"Creating"} />
						: (<>
							<Grid
								sx={{
									"& .MuiTextField-root": { m: 2, ml: 5, width: "70ch" },
									
								}}
								container
								direction='column'>
								<Grid item ys={6}>
									<TextField
										required
										id='collection_name'
										label='Collection'
										placeholder='Collection Name'
										value={newCollection.collection_name}
										onChange={handleTextFieldChange}
									/>
									,
									<TextField
										required
										id='details'
										label='Details'
										placeholder='Details'
										multiline
										maxRows={4}
										value={newCollection.details}
										onChange={handleTextFieldChange}
									/>
									<div style={{ margin: "0 3rem" }}>
										<FormLabel component="legend">Type</FormLabel>

										<RadioGroup aria-label="type" id="type" name="is_locked" value={newCollection.is_locked} style={{ display: "flex", flexDirection: "row" }} onChange={handleTextFieldChange}>
											<FormControlLabel id="type" value={true} control={<Radio />} label="Locked" />
											<FormControlLabel id="type" value={false} control={<Radio />} label="Unlocked" />
										</RadioGroup>
										<Button
											className='button'
											variant='contained'
											onClick={handleAllCV}
										// startIcon={ <AddIcon /> }
										>
											{!allCV ? "Show Only Cash Vouchers" : "Show All Vouchers"}
										</Button>
									</div>
								</Grid>
							</Grid>
							<OfferingTable handleRowSelection={handleRowSelection} allCV={allCV} />
						</>)
				}
			</DialogContent>
		</Dialog>


	</>
	);
}
